import { jsx } from "react/jsx-runtime";
const SquareIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1 1", children: /* @__PURE__ */ jsx("rect", { width: "1", height: "1" }) });
export {
  SquareIcon
};
